class ImageListSwiper extends HTMLElement {
    constructor() {
        super();
        this.swiper = null;
        this.swiperContainer = this.querySelector('.swiper');
        this.swipernext = this.querySelector('.swiper--nextfd');
        this.speed = this.getAttribute('data-speed') || 3000; // 获取滑动速度
        this.autoplayhe = parseInt(this.getAttribute('data-autoplayhe'));
    }

    connectedCallback() {
        this.initSwiper();
    }

    initSwiper() {
        if (this.swiperContainer) {
            // Swiper 基础配置对象
            let swiperConfig;
            const customSlidePerview = this.swiperContainer.getAttribute('data-slides-per-view');
            const eventPage = this.swiperContainer.getAttribute('data-page');
            if (eventPage == 'christmas') {
                swiperConfig = {
                    loop: true,
                    navigation: {
                        nextEl: this.swipernext,
                    },
                    // allowTouchMove: false,
                    // speed: parseInt(this.speed), // 使用从 data-speed 中获取的速度值
                    // freeMode: true,
                    slidesPerView: customSlidePerview,
                    spaceBetween: 16,

                    breakpoints: {
                        1024: {
                            spaceBetween: '1%', slidesPerView: customSlidePerview
                        },
                        20: {
                            spaceBetween: 0, slidesPerView: '1'
                        }
                    },
                };
            } else {
                swiperConfig = {
                    loop: true,
                    navigation: {
                        nextEl: this.swipernext,
                    },
                    // allowTouchMove: false,
                    // speed: parseInt(this.speed), // 使用从 data-speed 中获取的速度值
                    // freeMode: true,
                    slidesPerView: customSlidePerview,
                    spaceBetween: 16,

                    breakpoints: {
                        1024: {
                            spaceBetween: '1%', slidesPerView: customSlidePerview
                        },
                        769: {
                            spaceBetween: '1%', slidesPerView: customSlidePerview
                        },
                        20: {
                            spaceBetween: 0, slidesPerView: '1'
                        }
                    },
                };
            }

            // 如果 this.autoplayhe == 1，则添加 autoplay 配置
            let windowWidthSafe;
            if (eventPage == 'christmas') {
                windowWidthSafe = 1000;
            } else {
                windowWidthSafe = 768;
            }
            if (this.autoplayhe === 1 && $(window).width() > windowWidthSafe) {
                swiperConfig.autoplay = {
                    delay: 0,
                    disableOnInteraction: false,
                    stopOnLastSlide: false,
                };
                swiperConfig.freeMode = true;
                swiperConfig.allowTouchMove = false;
                swiperConfig.speed = parseInt(this.speed);
            } else {
                swiperConfig.autoplay = false;
                swiperConfig.freeMode = false;
                swiperConfig.allowTouchMove = true;
                swiperConfig.speed = 300;
            }
            console.log(swiperConfig);
            // 初始化 Swiper
            this.swiper = new Swiper(this.swiperContainer, swiperConfig);

            if (window.innerWidth > 999) {
                this.swiperContainer.addEventListener('mouseenter', () => {
                    this.swiper.autoplay?.stop();  // 停止自动播放，确保 autoplay 存在
                    this.swiper.allowTouchMove = false;  // 禁止触摸滑动
                    if (this.swiper.freeMode) {
                        this.swiper.setTranslate(this.swiper.getTranslate()); // 保持当前滑动位置
                    }
                    // this.swiper.freeMode.stop();// 暂停自由模式的惯性滑动
                    // this.swiper.setTranslate(this.swiper.getTranslate());  // 保持当前滑动位置
                    // console.log($(this.swiperContainer).find(".swiper-wrapper"));
                    // $(this.swiperContainer).find(".swiper-wrapper").css("transition-duration","0s !important")
                });

                this.swiperContainer.addEventListener('mouseleave', () => {
                    this.swiper.autoplay?.start();  // 重新开始自动播放，确保 autoplay 存在
                    this.swiper.allowTouchMove = true;  // 启用触摸滑动
                    this.swiper.slideTo(this.swiper.activeIndex);
                    // $(this.swiperContainer).find(".swiper-wrapper").css("transition-duration",parseInt(this.speed))
                    // this.swiper.freeMode.start(); // 继续允许惯性滑动
                });
            }
        }
    }
}

customElements.define('imagelist-swiper', ImageListSwiper);
